export default "__VITE_ASSET__BnuvSRfb__"